/**
 * Kiểm tra xem hóa đơn có phải là hóa đơn từ máy tính tiền hay không.
 * Điều kiện: Ký hiệu hóa đơn (invoiceSerial) có ký tự thứ 5 từ trái sang là 'M' hoặc 'm'.
 * Ví dụ: 1C26MYY, 2C26MYY, 5C26MYY
 */
export const isMachineInvoice = (invoiceSerial?: string | null): boolean => {
  if (!invoiceSerial || invoiceSerial.length < 5) {
    return false;
  }
  return invoiceSerial.charAt(4).toUpperCase() === "M";
};
